export default __webpack_public_path__ + "static/media/login_wp.00544ee7.jpg";